import React from "react";

const Info = ({ info }) => {
  if (!info) return null;

  const {
    info_title,
    info_img,
    download_pdf,
    slogan,
    facebook_text,
    facebook_img,
    facebook_url,
    facebook_share_url,
  } = info;

  const getMediaUrl = (media) => {
    if (!media) return null;
    if (Array.isArray(media)) {
      return media[0]?.url || null;
    }
    return media.url || null;
  };

  const infoImgUrl = getMediaUrl(info_img);
  const facebookImgUrl = getMediaUrl(facebook_img);
  const downloadUrl = download_pdf?.url || getMediaUrl(download_pdf);
  const facebookUrl = facebook_url;
  const facebookShareUrl = facebook_share_url;

  return (
    <div className="bg-white/95 backdrop-blur-md rounded-2xl shadow-2xl p-6 sm:p-7 lg:p-8 space-y-6">
      {/* Info Title */}
      {info_title && (
        <h2 className="text-xl sm:text-2xl font-bold text-gray-900">
          {info_title}
        </h2>
      )}

      {/* Info image + Download PDF button (grouped) */}
      {(infoImgUrl || downloadUrl) && (
        <div className="space-y-3">
          {infoImgUrl && (
            <div className="rounded-xl overflow-hidden shadow-md">
              <img
                src={infoImgUrl}
                alt={info_title || "Info image"}
                className="w-full h-auto object-contain"
              />
            </div>
          )}
          {downloadUrl && (
            <button
              type="button"
              onClick={() =>
                window.open(downloadUrl, "_blank", "noopener,noreferrer")
              }
              className="w-full inline-flex items-center justify-center px-4 py-2.5 rounded-full bg-green-600 text-white text-sm font-semibold shadow-md hover:bg-green-700 transition-colors"
            >
              Download PDF
            </button>
          )}
        </div>
      )}

      {/* Slogan */}
      {slogan && (
        <p className="text-gray-900 font-bold text-lg sm:text-2xl leading-relaxed border-t border-gray-100 pt-4 text-center">
          {slogan}
        </p>
      )}

      {/* Facebook Section */}
      {(facebook_text || facebookImgUrl || facebookUrl || facebookShareUrl) && (
        <div className="border-t border-gray-100 pt-4 space-y-3">
          {facebook_text && (
            <p className="text-gray-800 text-sm sm:text-base font-medium">
              {facebook_text}
            </p>
          )}

          {facebookImgUrl && (
            <div className="rounded-xl overflow-hidden shadow-md">
              <img
                src={facebookImgUrl}
                alt="Facebook"
                className="w-full h-auto object-contain cursor-pointer"
                onClick={() => {
                  if (facebookUrl) {
                    window.open(facebookUrl, "_blank", "noopener,noreferrer");
                  }
                }}
              />
            </div>
          )}

          <div className="flex flex-wrap justify-center gap-3">
            {facebookUrl && (
              <button
                type="button"
                onClick={() =>
                  window.open(facebookUrl, "_blank", "noopener,noreferrer")
                }
                className="inline-flex items-center px-4 py-2 rounded-full bg-blue-600 text-white text-xs sm:text-sm font-semibold shadow hover:bg-blue-700 transition-colors"
              >
                View on Facebook
              </button>
            )}
            {facebookShareUrl && (
              <button
                type="button"
                onClick={() =>
                  window.open(
                    facebookShareUrl,
                    "_blank",
                    "noopener,noreferrer"
                  )
                }
                className="inline-flex items-center px-4 py-2 rounded-full bg-blue-600 text-white text-xs sm:text-sm font-semibold shadow hover:bg-blue-700 transition-colors"
              >
                Share on Facebook
              </button>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Info;


